import colorPickerPaletteConstants from "@/constants/colorPickerPaletteConstants.js"

/** Max length for core value name and description text fields. */
const MAX_TEXT_FIELD_LENGTH = 250
const MAX_NAME_LENGTH = MAX_TEXT_FIELD_LENGTH
const MAX_DESCRIPTION_LENGTH = MAX_TEXT_FIELD_LENGTH

/** POST create — `apiV8nocache` base is already `/api/v8`. */
const CORE_VALUES_API_PATH = "/admin/pbis/core-values"

const DEFAULT_CATEGORY_COLOR = "#338FEB"
const CORE_VALUE_COLOR_PALETTE =
  colorPickerPaletteConstants.CORE_VALUE_COLOR_PALETTE

const STATUS = Object.freeze({
  ENABLED: "Enabled",
  DISABLED: "Disabled"
})

export default {
  MAX_TEXT_FIELD_LENGTH,
  MAX_NAME_LENGTH,
  MAX_DESCRIPTION_LENGTH,
  DEFAULT_CATEGORY_COLOR,
  CORE_VALUE_COLOR_PALETTE,
  CORE_VALUES_API_PATH,
  STATUS
}
